import {useQuery} from '@apollo/client';
import {GET_CLUBS} from 'packages/graphql/v2/queries';
import {Club} from 'packages/common-types/schema-types';
import {useEffect, useState} from 'react';
import {useModal} from 'packages/hooks/use-modal';
import {MenuItem, TableCell, TableRow} from '@material-ui/core';
import BaseTable from 'packages/tables/BaseTable';
import TableMenu from 'packages/common-ui/TableMenu';
import {CLUB_HEADERS} from 'packages/constants/table-constants';
import UpdateClub from 'packages/dialogs/UpdateClub';
import DeleteClub from 'packages/dialogs/DeleteClub';

type GetClubsData = {
  getClubs: Club[];
};

const Clubs = () => {
  const {data: registeredClubs} = useQuery<GetClubsData>(GET_CLUBS);
  const [selectedClub, setSelectedClub] = useState('');
  const {toggle, modalOpen} = useModal();
  const {toggle: toggleDelete, modalOpen: modalOpenDelete} = useModal();

  useEffect(() => {
    console.log(registeredClubs);
  }, [registeredClubs]);
  const renderTable = () => {
    return registeredClubs?.getClubs.map(({_id, name, address}) => {
      const {country, state, city} = address;
      return (
        <>
          <TableRow key={_id}>
            <TableCell component="th" scope="row">
              {name}
            </TableCell>
            <TableCell align="right" component="th" scope="row">
              {`${country},${state},${city}`}
            </TableCell>
            <TableCell align="right" component="th" scope="row">
              <TableMenu>
                <MenuItem
                  onClick={() => {
                    setSelectedClub(_id);
                    toggle();
                  }}
                >
                  Actualizar
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    setSelectedClub(_id);
                    toggleDelete();
                  }}
                >
                  Eliminar
                </MenuItem>
              </TableMenu>
            </TableCell>
          </TableRow>
        </>
      );
    });
  };
  return (
    <>
      <UpdateClub clubId={selectedClub} modalOpen={modalOpen} toggle={toggle} />
      <DeleteClub
        clubId={selectedClub}
        modalOpen={modalOpenDelete}
        toggle={toggleDelete}
      />
      <BaseTable headers={CLUB_HEADERS}>{renderTable()}</BaseTable>
    </>
  );
};

export default Clubs;
